import { MapPin } from "lucide-react";

export default function Location({ t }) {
  return (
    <section
      id="location"
      data-testid="location-section"
      className="relative bg-[#0A0A0A] text-white py-24 lg:py-40"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-4 mb-6">
              <span className="h-px w-10 bg-[#BEAF87]" />
              <span className="text-[11px] uppercase tracking-[0.35em] text-[#BEAF87] font-[Barlow_Semi_Condensed] font-medium">
                {t.location.eyebrow}
              </span>
            </div>
            <h2
              data-testid="location-title"
              className="font-[Cormorant_Garamond] font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight"
            >
              {t.location.title}
            </h2>
            <p className="mt-6 text-white/70 font-[Barlow_Semi_Condensed] max-w-md">
              {t.location.body}
            </p>

            <div className="mt-10 flex items-center gap-3 text-[#BEAF87] text-sm font-[Barlow_Semi_Condensed]">
              <MapPin size={16} />
              <span>Avenida Belo Horizonte, Setúbal, Portugal</span>
            </div>

            <div className="mt-10 space-y-3">
              {t.location.distances.map((d, i) => (
                <div
                  key={i}
                  data-testid={`distance-${i}`}
                  className="flex items-baseline justify-between border-b border-white/10 pb-3"
                >
                  <span className="font-[Barlow_Semi_Condensed] text-white/80">
                    {d.place}
                  </span>
                  <span className="font-[Cormorant_Garamond] text-2xl text-[#BEAF87]">
                    {d.time}
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7">
            <div
              data-testid="location-map"
              className="relative w-full h-[480px] lg:h-[640px] overflow-hidden border border-white/10"
            >
              <iframe
                title="Belo Horizonte Residences — Setúbal"
                src="https://www.google.com/maps?q=Avenida+Belo+Horizonte,+Set%C3%BAbal,+Portugal&output=embed"
                width="100%"
                height="100%"
                style={{ border: 0, filter: "grayscale(0.6) contrast(1.05) invert(0.88)" }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
